import {
    Book,
    Markdown as CommonMarkdown,
    MarkdownProps,
    ThemeProvider,
    useAsync,
    useThemeConfig
} from '@topwrite/common';
import Color from 'color';
import { useMemo } from 'react';
import { socket } from '../lib/socket';
import Anchor from './html/anchor';
import Attachment from './html/attachment';
import Audio from './html/audio';
import Img from './html/img';
import Video from './html/video';
import Loader from './loader';

interface Props extends MarkdownProps {
    prue?: boolean;
}

export default function Markdown({ children, components, prue = false, ...props }: Props) {

    if (prue) {
        return <CommonMarkdown
            {...props}
            components={components}
        >
            {children}
        </CommonMarkdown>;
    }

    const { result, loading } = useAsync(async () => {
        const buffer = await socket.readFile(Book.style);

        return buffer.toString();
    }, []);

    const mergedComponents = useMemo(() => {
        return {
            img: Img,
            attachment: Attachment,
            video: Video,
            audio: Audio,
            a: Anchor,
            ...components
        };
    }, [components]);

    const themeConfig = useThemeConfig();

    const theme = useMemo(() => {
        return {
            primaryColor: new Color(themeConfig.primaryColor),
        };
    }, [themeConfig]);

    if (loading) {
        return <Loader />;
    }

    return <ThemeProvider theme={theme}>
        <CommonMarkdown css={result} aside={false} {...props} components={mergedComponents}>
            {children}
        </CommonMarkdown>
    </ThemeProvider>;
}
